import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1ec04ee2&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=1ec04ee2&prod&lang=less"
import style1 from "./list.vue?vue&type=style&index=1&id=1ec04ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec04ee2",
  null
  
)

export default component.exports